module.exports = __webpack_public_path__ + "img/reloj-icono.7ee811ac.webp";